import {Action} from '@reduxjs/toolkit'
import {AccountModel} from './models/AccountModel'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetAccount: '[SetAccount] Action',
}

const initialAuthState: IAccountState = {
  appAccount: undefined,
}

export interface IAccountState {
  appAccount?: AccountModel
}

export const reducer = persistReducer(
  {storage, key: 'fleksUpAccount', whitelist: ['appAccount']},
  (state: IAccountState = initialAuthState, action: ActionWithPayload<IAccountState>) => {
    switch (action.type) {
      case actionTypes.SetAccount: {
        const appAccount = action.payload?.appAccount
        return {
          ...state,
          appAccount,
        }
      }
      default:
        return state
    }
  }
)
export const actions = {
  setAccount: (appAccount: AccountModel) => {
    return {
      type: actionTypes.SetAccount,
      payload: {
        appAccount: appAccount,
      },
    }
  },
}

export function* saga() {}
